var render = function render(){var _vm=this,_c=_vm._self._c;return _c('editor',{key:"default",attrs:{"api-key":_vm.apiKey,"init":_vm.initEditorSettings},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }